
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { utils_tool, component_tool, framework_tool } from '@/tool'
import { WizTableForm, WizDataAuthSelect } from '@/containers/common'
import WorkflowAuthSelectForm from './workflowAuthSelectForm'
let { WizButton, WizCard, WizAntdForm, WizRow, WizCol } = component_tool;
let { WizContainer } = framework_tool
let { Item } = WizAntdForm
const workflowAuditMethodConfig = WizTableForm.Config.workflowAuditMethod(this, { apiParams: { state: 1 } })
class WorkflowAuthSelectDetail extends Component {

  componentName = 'workflowAuthSelectDetail';
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  handleSubmit = e => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let { submit } = this.props;
        submit(values)
      }
    });
  };

  handleNext() {

    let { next } = this.props
    next && next()
  }
  handlePrev() {
    let { prev } = this.props
    prev && prev()
  }

  handleReset = () => {
    //重置表单
    this.props.form.resetFields();
  };

  render() {
    let { form, title,next, initialValue } = this.props
    let initRows = []
    return (
      <WizAntdForm onSubmit={this.handleSubmit}>
        {
          form.getFieldDecorator('dataAuth', { initialValue: initialValue })(
            <WorkflowAuthSelectForm />
          )
        }
        <WizAntdForm.Item wrapperCol={{ span: 12, offset: 6 }}>
          <WizRow className="form-btns row-item">
            <WizCol span={24} style={{ textAlign: 'center' }}>
              <WizButton title="上一步" type="primary" htmlType='submit' onClick={e => this.handlePrev()}>上一步</WizButton>
              {next?<WizButton title='保存并进入下一步' type='primary' htmlType='submit'
                onClick={e => this.handleNext()}>保存并进入下一步</WizButton>:null}
              <WizButton title='保存并返回' htmlType='submit'>保存并返回</WizButton>
              <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                重置
              </WizButton>
            </WizCol>
          </WizRow>
        </WizAntdForm.Item>
      </WizAntdForm>

    )
  }

}

export default WizAntdForm.create()(WorkflowAuthSelectDetail);

/**
 * 默认值
 */
WorkflowAuthSelectDetail.defaultProps = {
  title: '数据权限选择',

}
/**
 * props入参校验
 */
WorkflowAuthSelectDetail.propTypes = {
  title: PropTypes.string.isRequired,//卡片标题
  submit: PropTypes.fun,//提交的回调方法
}
